import useSimpleModal from '@/Components/Modal/useSimpleModal';
import { VIEWING_METHODS } from '@/Hooks/PUJ/constants';
import usePackageOfferDetails from '@/Hooks/PUJ/usePackageOfferDetails';
import usePujFlag from '@/Hooks/usePujFlag';
import { useSubscriptionModal } from '@/Hooks/useSubscription';
import { actions, utils } from '@/Store';
import navigateToPackage, { getOfferIdFromViewingMethod } from '@/Utils/Puj';
import React, { useCallback, useEffect, useRef } from 'react';
import { useModal } from 'react-modal-hook';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import AiringSlotModalDetails from './AiringSlotModalDetails';

const useAiringSlotModal = () => {
  const dispatch = useDispatch();
  const showUpgradeSubscriptionModal = useSubscriptionModal();
  const { isPUJEnabled } = usePujFlag();
  const location = useLocation();
  const history = useHistory();
  const { openModal } = useSimpleModal();
  const { getLinearChannelViewingMethods } = usePackageOfferDetails();
  // Mounted flag to prevent state update on unmounted component
  const isMounted = useRef(true);
  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  const [showModal, hideModal] = useModal(() => {
    return (
      <AiringSlotModalDetails
        onClose={() => {
          hideModal();
          dispatch(actions.channels.clearSelectedChannelSlot());
        }}
      />
    );
  });

  const openWatchFromStartModal = useCallback(
    async assetId => {
      const result = await dispatch(actions.channels.fetchLinearSlotById(assetId));
      if (!isMounted.current) return; // Check if still mounted
      const selectedSlot = result.payload?.linearChannelSlot;
      if (!utils.entitlements.getSlotSubscriptions(selectedSlot)) {
        const subscriptions = utils.title.getSubscriptions(selectedSlot.channel);

        if (isPUJEnabled) {
          const customOnOk = async () => {
            const viewingMethods = await getLinearChannelViewingMethods(selectedSlot?.channel.id);
            const offerId = await getOfferIdFromViewingMethod(
              viewingMethods,
              VIEWING_METHODS.LINEAR,
            );
            navigateToPackage({
              offerId,
              history,
              location,
              openModal,
            });
          };
          showUpgradeSubscriptionModal(subscriptions, undefined, false, customOnOk);
        } else {
          showUpgradeSubscriptionModal(subscriptions);
        }

        return;
      }
      showModal();
    },
    [
      dispatch,
      showModal,
      history,
      location,
      openModal,
      showUpgradeSubscriptionModal,
      getLinearChannelViewingMethods,
      isPUJEnabled,
    ],
  );

  return { openWatchFromStartModal };
};

export default useAiringSlotModal;
